/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { ChangeEvent, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import style from './filter.module.scss';
import { FilterInterface, SearchDataInterface } from './filterTypes';
import Input from '../../UI/input/inputComponent';
import { INPUT_TYPE } from '../../UI/input/inputTypes';
import DropDownMenu from '../../UI/dropDownMenu/dropDownMenu';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import { INPUT_GLOBAL_TYPES } from '../../constants/constants';
import { useDispatch } from '../..';
import {
  getFilteredListings,
  setPageNumber,
  setSearchData,
} from '../../service/ListingData';

const Filter: React.FC<FilterInterface> = ({
  optionCities,
  optionTypes,
  searchData,
}) => {
  const [formData, setFormData] = useState<SearchDataInterface>({
    name: '',
    category: 'Авто',
    city: 'Москва',
    price: 0,
  });
  const dispatch = useDispatch();

  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 800 }),
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    console.log(formData);
  };

  const submit = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    console.log(`Form Data: ${formData}`);
  };

  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    console.log('is srearch');
    const filters = {
      name: formData.name,
      category: formData.category,
      city: formData.city,
      price: formData.price,
    };
    dispatch(setSearchData(filters));
    dispatch(setPageNumber(1));
    dispatch(getFilteredListings({ filters, page: 1 }));
  };

  return (
    <form
      className={resolution.DesktopOrLaptop ? style.shell : style.shellMobile}
      // onSubmit={handleSearch}
    >
      <Input
        ver={INPUT_TYPE.SEARCH}
        placeholder="Я хочу купить..."
        customWidth={1320}
        errStatus={false}
        onChange={handleChange}
        name="name"
        customMargin={0}
      />
      <div
        className={
          resolution.DesktopOrLaptop ? style.flexRow : style.flexColumn
        }
      >
        <DropDownMenu
          options={optionTypes}
          onChange={handleChange}
          name="category"
          customWidth={!resolution.DesktopOrLaptop ? 800 : 312}
          isMobile={!resolution.DesktopOrLaptop}
        />
        <DropDownMenu
          options={optionCities}
          onChange={handleChange}
          name="city"
          customWidth={!resolution.DesktopOrLaptop ? 800 : 312}
          isMobile={!resolution.DesktopOrLaptop}
        />
        <Input
          placeholder="Стоимость"
          ver={INPUT_TYPE.REGULAR}
          errStatus={false}
          onChange={handleChange}
          name="price"
          accept={INPUT_GLOBAL_TYPES.Number}
          customWidth={!resolution.DesktopOrLaptop ? 800 : 312}
        />
        <Button
          ver={BUTTON_VER.secondary}
          text="Применить"
          customWidth={!resolution.DesktopOrLaptop ? 800 : 152}
          type={BUTTON_TYPE.Submit}
          onClick={handleSearch}
        />
      </div>
    </form>
  );
};

export default Filter;
